<template>
  <div class="card shadow-sm mb-4">
    <div class="card-header bg-accent">
      <h4 class="mb-0 text-white fs-1vw">مدیریت اختیارات و مسئولیت‌ها</h4>
    </div>
    <div class="card-body">
      <div class="row mb-3 align-items-end">
        <div class="col-md-5">
          <label class="form-label fw-bold">شرح</label>
          <select class="form-select" v-model="newItem.overview">
            <option value="" disabled>شرح را انتخاب کنید</option>
            <option v-for="(overview, index) in overviews" :key="index" :value="overview">
              {{ overview }}
            </option>
          </select>
        </div>
        <div class="col-md-5">
          <label class="form-label fw-bold">توضیحات</label>
          <input
              type="text"
              class="form-control"
              placeholder="توضیحات را وارد کنید"
              v-model="newItem.description"
          />
        </div>
        <div class="col-md-2">
          <GeneralButton @clicked="addItem"/>
        </div>
      </div>
      <hr class="my-3">

      <!-- Items Table -->
      <GeneralTable
          :headers="['شرح', 'توضیحات']"
          :fields="['overview', 'description']"
          :items="powers"
          :openEditModalMethod="openEditModal"
          @remove="removeItem"
      />

      <!-- Edit Item Modal -->
      <GeneralModal
          v-show="editedItem"
          title="ویرایش اختیارات"
          modal-id="powerModalId"
          @save="updateItem"
      >
        <div class="row mb-3">
          <div class="col-md-6">
            <label class="form-label fw-bold">شرح</label>
            <select class="form-select" v-if="editedItem" v-model="editedItem.overview">
              <option value="" disabled>شرح را انتخاب کنید</option>
              <option v-for="(overview, index) in overviews" :key="index" :value="overview">
                {{ overview }}
              </option>
            </select>
          </div>
          <div class="col-md-6">
            <label class="form-label fw-bold">توضیحات</label>
            <input
                type="text"
                class="form-control"
                placeholder="توضیحات را وارد کنید"
                v-if="editedItem"
                v-model="editedItem.description"
            />
          </div>
        </div>
      </GeneralModal>
    </div>
  </div>
</template>

<script>
import GeneralTable from "@/components/JobDescription/GeneralComponents/GeneralTable.vue";
import GeneralModal from "@/components/JobDescription/GeneralComponents/GeneralModal.vue";
import GeneralButton from "@/components/JobDescription/GeneralComponents/GeneralButton.vue";
import { Modal } from 'bootstrap';
import { useToast } from "vue-toastification";

const baseStructure = {
  overview: '',
  description: '',
};

const toast = useToast();

export default {
  components: { GeneralButton, GeneralTable, GeneralModal },

  created() {
    this.$store.dispatch('crudActions/fetchInitialData', {
      endpoint: '/powers/index',
      afterMutation: 'powers/setPowers'
    });
  },

  data() {
    return {
      newItem: structuredClone(baseStructure),
      overviews: [
        'منابع انسانی',
        'منابع فیزیکی',
        'منابع مالی',
        'فرم و گزارشها',
        'استقلال کاری و محدوده عمل',
      ],
      editedItem: null,
      editIndex: null,
    };
  },

  computed: {
    powers: {
      get() {
        return this.$store.state.powers.powers;
      },
      set(value) {
        this.$store.commit('powers/setPowers', value);
      }
    },
  },

  methods: {
    async addItem() {
      if (!this.checkItemValidation(this.newItem)) {
        return;
      }

      const response = await this.$store.dispatch('crudActions/create', {
        resourceData: this.newItem,
        endpoint: '/powers/store',
      });

      this.powers = [...this.powers, structuredClone(response.data)];
      this.newItem = structuredClone(baseStructure);
    },

    removeItem(index) {
      const power = this.powers.find((_, i) => i === index);
      this.powers = this.powers.filter((_, i) => i !== index);

      this.$store.dispatch('crudActions/delete', {
        resourceId: power.id,
        endpoint: '/powers/delete',
      });
    },

    openEditModal(item, index) {
      this.editedItem = structuredClone(item);
      this.editIndex = index;
      const modal = Modal.getOrCreateInstance(document.getElementById('powerModalId'));
      modal.show();
    },

    updateItem() {
      if (this.editIndex === null) {
        return;
      }

      if (!this.checkItemValidation(this.editedItem)) {
        return;
      }

      this.powers.splice(this.editIndex, 1, { ...this.editedItem });

      this.$store.dispatch('crudActions/update', {
        resourceData: this.editedItem,
        endpoint: '/powers/update',
      });

      this.editIndex = null;
      this.editedItem = null;
      const modal = Modal.getOrCreateInstance(document.getElementById('powerModalId'));
      modal.hide();
    },

    checkItemValidation(item) {
      if (!item.overview || !item.description) {
        toast.error('همه فیلدها را کامل وارد کنید!');
        return false;
      }
      return true;
    }
  }
};
</script>
